export enum ContainerPadding {
  MD = 'md',
  SM = 'sm',
}

export enum ContainerSize {
  MD = 'md',
  SM = 'sm',
}

export enum ContainerVariant {
  Centered = 'centered',
  Form = 'form',
}
